import { useMemo } from 'react';
import { DEFAULT_PLAYER_POSITION } from '../game-map/core.mjs';
import { usePlayerLocation } from '../game-map/PlayerLocationContext';

export function useUserGeolocation() {
  const player = usePlayerLocation();
  const location = player.position;
  const now = Date.now();
  const ageMs = location?.receivedAt ? Math.max(0, now - Number(location.receivedAt)) : null;
  const userPos = useMemo(() => (location ? [location.latitude, location.longitude] : null), [location]);

  return {
    location,
    userPos,
    accuracy: location?.accuracy ?? null,
    timestamp: location?.timestamp ?? null,
    receivedAt: location?.receivedAt ?? null,
    ageMs,
    now,
    ready: player.status !== 'requesting',
    error: player.error,
    status: player.status,
    defaultPosition: [DEFAULT_PLAYER_POSITION.latitude, DEFAULT_PLAYER_POSITION.longitude],
    coords: location,
    start: player.start,
    stop: player.stop,
    recenter: player.recenter,
    requestFreshPosition: player.requestFreshPosition,
    freshPositionPending: player.freshPositionPending,
    isSecureContext: player.isSecureContext,
  };
}

export default useUserGeolocation;
